import { render, staticRenderFns } from "./VacationGntGubunMenuView.vue?vue&type=template&id=6af474ce&"
import script from "./VacationGntGubunMenuView.vue?vue&type=script&lang=js&"
export * from "./VacationGntGubunMenuView.vue?vue&type=script&lang=js&"
import style0 from "./VacationGntGubunMenuView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VRow})
